<script lang="ts" setup>
import { useDisplay } from 'vuetify'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'
import PreviewBarModal from '@/components/app/PreviewBarModal.vue'
import { checkPermissions } from '@/composable/useCheckPermissions'
import { UserProfilePermissionLevel } from '@/enums/UserProfilePermissionLevel'

const { mdAndUp } = useDisplay()
const appStore = useAppStore()
const authStore = useAuthStore()

const returnToOldMyHQ = () => {
  if (appStore.config.MYHQ_BASE_URL) window.location.href = appStore.config.MYHQ_BASE_URL
}

const forceNewMyHQ = computed(() => {
  return (
    authStore.organisation?.myhq_version === 'force_new'
    || !checkPermissions(UserProfilePermissionLevel.ADMIN)
  )
})
</script>

<template>
  <VContainer
    class="preview-bar"
    fluid
  >
    <VRow>
      <VCol
        v-if="authStore.authenticated"
        class="d-flex justify-center align-center"
      >
        <div
          v-if="mdAndUp"
          v-dompurify-html="$t('preview_bar.new_myhq')"
          class="mr-4"
        />
        &nbsp;
        <VBtn
          v-if="!forceNewMyHQ"
          class="mr-2"
          color="dark"
          rounded="xl"
          size="small"
          variant="outlined"
          @click="returnToOldMyHQ"
        >
          {{ $t('preview_bar.return_to_old_version') }}
        </VBtn>
        <span v-if="checkPermissions(UserProfilePermissionLevel.ADMIN) && authStore.organisation?.myhq_version === 'old'">
          |
          <VBtn
            class="ml-2"
            color="primary"
            rounded="xl"
            size="small"
            outlined
            @click="appStore.showPreviewBarModal = true"
          >
            {{ $t('preview_bar.make_default') }}
          </VBtn>
        </span>
      </VCol>
    </VRow>
    <PreviewBarModal />
  </VContainer>
</template>

<style scoped lang="scss">
.preview-bar {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  padding: 0.5rem 1rem;
  font-weight: bold;
  line-height: 2.25rem;
  background-color: rgb(var(--v-theme-background));
}
</style>
